export const OAUTH_NEXT_REDIRECT_STATE_PARAM_KEY = 'next'
